export default __webpack_public_path__ + "static/smellsLikeMarshmallow-cf32ee87834fc098b529e9b03597803e.png";